// Main locations (is_main_location, set in admin "Lokalizacje") are shown first
// and apart from the rest in every admin location picker.

const byName = (a, b) => (a.name || "").localeCompare(b.name || "", "pl");

export function splitLocations(locations = []) {
  const main = [];
  const other = [];
  locations.forEach((location) => {
    (location.is_main_location ? main : other).push(location);
  });
  return { main: main.sort(byName), other: other.sort(byName) };
}

export function sortLocationsMainFirst(locations = []) {
  const { main, other } = splitLocations(locations);
  return [...main, ...other];
}
